import { createConfig } from "@Utils/createConfig";
import { gatewayUrl } from "@Constants/gatewayUrl";
import axios from "axios";
export async function deleteSavedPrompt(token, id) {
    const header = createConfig(token);
    const url = `${gatewayUrl}/chats/promptBank/${id}`;
    try {
        await axios.delete(url, header);
    } catch (error) {
        console.error("Error deleting saved prompt:", error);
        throw new Error("Failed to delete saved prompt");
    }
}
